var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacchina50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "macchina-50") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "macchina-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,25 C50,38.8070566 38.8071069,50 25.0001123,50 C11.1928931,50 0,38.8070566 0,25 C0,11.1929434 11.1928931,0 25.0001123,0 C38.8071069,0 50,11.1929434 50,25",
    id: "Fill-1-Copy",
    fill: "#0478BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,37.2711043 C20.5167826,37.2711043 16.8695652,33.623887 16.8695652,29.1406696 C16.8695652,24.6574522 20.5167826,21.0102348 25,21.0102348 C29.4832174,21.0102348 33.1304348,24.6574522 33.1304348,29.1406696 C33.1304348,33.623887 29.4832174,37.2711043 25,37.2711043 M25,18.140879 C21.7774783,18.140879 18.8830435,19.54217 16.8695652,21.7574533 L16.8695652,10 L14,10 L14,29.1302527 C14,29.1340787 14,29.1369482 14,29.1407743 C14,35.2060209 18.9346957,40.1406696 25,40.1406696 C31.0653043,40.1406696 36,35.2060209 36,29.1407743 C36,23.0755277 31.0653043,18.140879 25,18.140879",
    id: "Page-1",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacchina50);
export default __webpack_public_path__ + "static/media/macchina-50.ca6c1851f9890a95fce69dceb1afc68e.svg";
export { ForwardRef as ReactComponent };